import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
});

export async function fetchSymbols() {
  const { data } = await api.get('/symbols/');
  return data;
}

export async function fetchHistoricalIV(symbol, days = null) {
  const params = {};
  if (days) params.days = days;
  const { data } = await api.get(`/historical-iv/${symbol}/`, { params });
  return data;
}

export async function fetchIVAnalysis(symbol, date = null) {
  const params = {};
  if (date) params.date = date;
  const { data } = await api.get(`/iv-analysis/${symbol}/`, { params });
  return data;
}

export async function fetchScripAnalysis(symbol, days = 90) {
  const { data } = await api.get(`/scrip-analysis/${symbol}/`, { params: { days } });
  return data;
}

export async function fetchGBMBands(symbol) {
  const { data } = await api.get(`/gbm-bands/${symbol}/`);
  return data;
}

export async function fetchMaxPainChain(symbol) {
  const { data } = await api.get(`/max-pain-chain/${symbol}/`);
  return data;
}
